import m from "../../geodata/es2015/continentsRussiaAsiaLow";
window.am4geodata_continentsRussiaAsiaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/continentsRussiaAsiaLow.js
// module id = null
// module chunks = 